import React from "react";
import { Link } from "react-router-dom";
import ServicesImage from "../../images/hero_bg.jpg";
import WhatsaAppIcon from "../../images/whatsapp.jpg";

const RealEstateServices = () => {
  const whatsappURL = "https://wa.me/+923487172565";
  
  // Open WhatsApp URL
  const contact = () => window.open(whatsappURL, "_blank");
  
  return (
    <div className="relative flex flex-col md:flex-row items-center justify-between px-6 py-16 md:py-24 bg-gradient-to-r from-emerald-50 to-teal-50 overflow-hidden">
      {/* Background decorative elements */}
      <div className="absolute -top-24 -left-24 w-64 h-64 rounded-full bg-emerald-200 opacity-20"></div>
      <div className="absolute -bottom-24 -right-24 w-64 h-64 rounded-full bg-teal-200 opacity-20"></div>
      
      <div className="relative z-10 bg-white p-8 md:p-10 rounded-2xl shadow-lg text-center md:text-left w-full md:w-7/12 lg:w-5/12 transform transition-all duration-300 hover:shadow-xl">
        <h1 className="text-3xl md:text-4xl font-bold mb-6 bg-gradient-to-r from-emerald-600 to-teal-600 bg-clip-text text-transparent">
          Professional Real Estate Services
        </h1>
        <p className="text-gray-700 text-lg mb-8 leading-relaxed">
          What are you waiting for? Contact us right now if you want to <span className="font-semibold text-emerald-600">buy or sell your property through us</span>, <span className="font-semibold text-emerald-600">find rental properties</span>, or <span className="font-semibold text-emerald-600">list your agency on EstateGhar</span>. We'll manage everything for you from top to bottom and keep you relaxed.
        </p>
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-6">
          <div className="bg-emerald-50 p-4 rounded-lg border border-emerald-200">
            <h3 className="font-semibold text-emerald-800 mb-2">Property Sales</h3>
            <p className="text-sm text-gray-600">Expert assistance with buying or selling properties</p>
          </div>
          <div className="bg-teal-50 p-4 rounded-lg border border-teal-200">
            <h3 className="font-semibold text-teal-800 mb-2">Rental Services</h3>
            <p className="text-sm text-gray-600">Find tenants or rental properties effortlessly</p>
          </div>
        </div>
        
        <div
          onClick={contact}
          className="inline-flex items-center justify-center space-x-3 bg-gradient-to-r from-emerald-500 to-green-500 py-4 px-8 rounded-xl hover:from-emerald-600 hover:to-green-600 transition-all duration-300 transform hover:-translate-y-1 shadow-md hover:shadow-lg cursor-pointer"
        >
          <img
            src={WhatsaAppIcon}
            className="w-8 h-8 rounded-full"
            alt="WhatsApp"
          />
          <span className="text-white font-semibold text-xl">
            Contact Our Agents
          </span>
        </div>
        
        <p className="text-sm text-gray-600 mt-4">
          ✓ Professional property valuation ✓ Marketing & photography ✓ Legal assistance ✓ Tenant screening
        </p>
      </div>

      <div className="relative z-10 w-full md:w-2/5 mt-10 md:mt-0">
        <div className="relative">
          <img
            src={ServicesImage}
            alt="Professional real estate services"
            className="w-full rounded-2xl shadow-lg transform transition-all duration-500 hover:scale-105"
          />
          <div className="absolute inset-0 bg-gradient-to-t from-emerald-900/20 to-transparent rounded-2xl"></div>
        </div>
        
        {/* Decorative element */}
        <div className="hidden lg:block absolute -bottom-6 -right-6 w-24 h-24 rounded-full bg-gradient-to-r from-emerald-400 to-teal-500 opacity-20"></div>
      </div>
    </div>
  );
};

export default RealEstateServices;